import React from 'react';

import { Svg, type SvgProps } from './svg';

export function SwapIcon(props: SvgProps) {
  return (
    <Svg data-testid="swap-icon" {...props}>
      <path d="M9.01 14.2857H2V16.5714H9.01V20L13 15.4286L9.01 10.8571V14.2857ZM14.99 13.1429V9.71429H22V7.42857H14.99V4L11 8.57143L14.99 13.1429Z" />
    </Svg>
  );
}
